import React from "react";
import { Route, Redirect } from "react-router-dom";
import Authorization from "../utility/authorization";
import Application from "../containers/Application";

/**
 * If we have a logged-in user, display the component, otherwise redirect to login page.
 */
const PrivateRoute = ({ component: Component, meta, permission, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (Authorization.isLoggedIn()) {
          const user = Authorization.getAuthUser();
          const { pathname } = props.location;
          // Routes only for roles 1 and 3 (operators, vendors, corporate, TMC,
          // branch managers, Analytics Dashboard V2): send other roles home
          if (
            (user.roleId !== 3 && user.roleId !== 1) &&
            (pathname === "/analytics-dashboard-v2" ||
              pathname === "/users/operators/operator" ||
              pathname.startsWith("/users/operators/operator/addOperator/") ||
              pathname === "/vendor" ||
              pathname.startsWith("/vendor-new/") ||
              pathname === "/users/drivers/corporate-driver" ||
              pathname.startsWith("/users/drivers/corporate-driver/add") ||
              pathname === "/users/corporate-vehicle" ||
              pathname.startsWith("/users/corporate-vehicle/add") ||
              pathname === "/vendor" ||
              pathname.startsWith("/vendor-new/add") ||
              pathname === "/tmc" ||
              pathname.startsWith("/tmc-new/add") ||
              pathname === "/corporate-new" ||
              pathname.startsWith("/corporate-new/add") ||
              pathname === "/branch-managers" ||
              pathname.startsWith("/branch-manager/add"))

          ) {
            return <Redirect to="/" />; // Redirect to homepage
          }

          if (
            user.roleId !== 1 &&
            (
              pathname === "/aggregator" ||
              pathname.startsWith("/aggregator-new/add") ||
              pathname.startsWith("/fares/hot-routes") ||
              pathname.startsWith("/fares/geofence") ||
              pathname.startsWith("/fares/fixed-fare") ||
              pathname.startsWith("/route-based-fare") ||
              pathname.startsWith("/fares/operating-area") ||
              pathname.startsWith("/promo-codes") ||
              pathname.startsWith("/operator-discount") ||
              pathname.startsWith("/reports") ||
              pathname.startsWith("/tripsheet") ||
              pathname.startsWith("/uploadcenter") ||
              pathname.startsWith("/site-settings") ||
              pathname.startsWith("/vehicle-types") ||
              pathname.startsWith("/taxida-commission") ||
              pathname.startsWith("/users/admins") ||
              pathname.startsWith("/users/controllers")
            )
          ) {
            return <Redirect to="/" />; // Redirect to homepage
          }

          // Un-comment below code when implement the roles & permission

          // if(permission && !Authorization.isAuthorizedPage(permission)){
          //     Component = Loadable({
          //         loader: () => import ('../error/AccessDenied'),
          //         loading: Loader,
          //     })
          // }

          return (
            <Application
              {...props}
              isLoggedIn={Authorization.isLoggedIn}
              auth={Authorization}
              component={Component}
            />
          );
        } else {
          sessionStorage.setItem("proute", JSON.stringify(props.location));
          return <Redirect to={{ pathname: "/" }} />;
        }
      }}
    />
  );
};
export default PrivateRoute;
